var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
//import { IMG_ENDPOINT } from '../../environments/environment';
var ThumbnailPipe = /** @class */ (function () {
    function ThumbnailPipe() {
    }
    ThumbnailPipe.prototype.transform = function (src, w, h) {
        if (w === void 0) { w = ''; }
        if (h === void 0) { h = ''; }
        if (!src) {
            return '';
        }
        var url_obj = new URL(window.location.href);
        if (url_obj['hostname'] == 'localhost' || src.indexOf('?src=') == -1) {
            return src;
        }
        var size = '';
        if (w) {
            size += '&w=' + w;
        }
        if (h) {
            size += '&h=' + h;
        }
        src = src + size;
        //src = IMG_ENDPOINT + '/cache/?src=' + src + size;
        return src;
    };
    ThumbnailPipe = __decorate([
        Pipe({
            name: 'thumbnail',
        })
    ], ThumbnailPipe);
    return ThumbnailPipe;
}());
export { ThumbnailPipe };
//# sourceMappingURL=thumbnail.js.map


// WEBPACK FOOTER //
// ./src/pipes/thumbnail/thumbnail.ts.pre-build-optimizer.js